import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { Popover } from '@bluebeam/react-skyline-popover';
import { FocusScope } from '@react-aria/focus';
import { DismissButton, useOverlay, useOverlayPosition } from '@react-aria/overlays';
import { mergeProps, useObjectRef } from '@react-aria/utils';
import { forwardRef } from 'react';
const updatePositionUsingAnchorPoint = (anchorPoint, popoverRef, style) => {
    if (!anchorPoint || !popoverRef.current || !style) {
        return;
    }
    let horizontalOrigin = 'left';
    let x = anchorPoint.x + 8;
    if (x + popoverRef.current.clientWidth > window.innerWidth) {
        horizontalOrigin = 'left';
        x = window.innerWidth - x;
    }
    let verticalOrigin = 'top';
    let y = anchorPoint.y + 8;
    if (y + popoverRef.current.clientHeight > window.innerHeight) {
        verticalOrigin = 'bottom';
        y = window.innerHeight - y + 24;
    }
    style.position = 'fixed';
    if (horizontalOrigin === 'left') {
        style.left = `${x}px`;
        style.right = undefined;
    }
    else {
        style.left = undefined;
        style.right = `${x}px`;
    }
    if (verticalOrigin === 'top') {
        style.top = `${y}px`;
        style.bottom = undefined;
    }
    else {
        style.top = undefined;
        style.bottom = `${y}px`;
    }
};
const MenuPopover = forwardRef(({ anchorPoint, children, isOpen, minWidth, offset, onClose, placement, targetRef, width }, ref) => {
    const popoverRef = useObjectRef(ref);
    const { overlayProps } = useOverlay({
        isDismissable: true,
        isOpen,
        onClose,
        shouldCloseOnBlur: true,
    }, popoverRef);
    const { overlayProps: positionProps } = useOverlayPosition({
        containerPadding: 0,
        isOpen,
        offset,
        onClose,
        overlayRef: popoverRef,
        placement: placement,
        targetRef,
    });
    updatePositionUsingAnchorPoint(anchorPoint, popoverRef, positionProps.style);
    return (_jsxs(Popover, { ...mergeProps(overlayProps, positionProps), className: buildClassName('elevation-2', {
            'min-w-[160px]': !width,
        }), ref: popoverRef, style: {
            ...mergeProps(overlayProps.style, positionProps.style, {
                minWidth,
                width,
            }),
        }, children: [_jsx(FocusScope, { restoreFocus: true, children: children }), _jsx(DismissButton, { onDismiss: onClose })] }));
});
export default MenuPopover;
//# sourceMappingURL=MenuPopover.js.map